import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import Cookies from "js-cookie"

import { get } from "common/utils/get"
import constants from "common/consts/config"
import { setOption } from "common/services/options/actions"
import RadioButtons from "common/components/RadioButtons/RadioButtons"
import NewTextField from "common/components/NewTextField/NewTextField"
import Button from "common/components/Button/Button"

const apiButtons = [
  {
    label: "production (disabled)",
    // value added later
  },
  {
    value: "mockApiUrl",
    label: "mocks",
  },
  {
    value: "custom",
    label: "custom",
  },
]

export const API_URLS = {
  apiUrl: "https://api.skypicker.com",
  metaApiUrl: "https://api.skypicker.com/meta-search",
  umbrellaUrl: "https://api.skypicker.com/umbrella/graphql",
  bookingApiUrl: "https://booking-api.skypicker.com",
  piciApiUrl: "https://fe.payments-kiwi.com/frei/",
  mmbApiUrl: "https://booking-api.skypicker.com",
  authApiUrl: "https://auth.skypicker.com",
  locationsApiUrl: "https://api.skypicker.com/locations/",
  mockApiUrl: "https://skymock.skypicker.com",
  graphqlApiUrl: "https://graphql.kiwi.com/",
}

/** "" means mocks are not supported */
const MOCK_API_URLS = {
  metaApiUrl: "https://skymock.skypicker.com/meta",
  piciApiUrl: "https://fe.payments-kiwi-dev.com/frei/",
  umbrellaUrl: "",
  graphqlApiUrl: "",
}

class ChangeAPISection extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    apiType: PropTypes.oneOf([
      "apiUrl",
      "metaApiUrl",
      "umbrellaUrl",
      "mockApiUrl",
      "bookingApiUrl",
      "piciApiUrl",
      "mmbApiUrl",
      "authApiUrl",
      "locationsApiUrl",
      "graphqlApiUrl",
    ]),
    // connected
    options: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    const { options, apiType } = this.props

    let selectedType = "custom"
    const currentApiSetUrl = options.get(apiType)
    // set type according to value in options
    if (currentApiSetUrl === API_URLS[apiType]) {
      selectedType = apiType
    } else if (
      get(apiType, MOCK_API_URLS) === currentApiSetUrl ||
      (!MOCK_API_URLS[apiType] && currentApiSetUrl === API_URLS.mockApiUrl)
    ) {
      selectedType = "mockApiUrl"
    }
    this.state = {
      url: currentApiSetUrl, // url set in initDebugWindow
      selectedType,
    }

    this.handleUrlChange = this.handleUrlChange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.saveUrl = this.saveUrl.bind(this)
  }

  handleUrlChange(url) {
    const { apiType } = this.props
    let newType = "custom"
    if (url === API_URLS[apiType]) {
      newType = apiType
    } else if (
      (MOCK_API_URLS[apiType] && url === MOCK_API_URLS[apiType]) ||
      (!MOCK_API_URLS[apiType] && url === API_URLS.mockApiUrl)
    ) {
      newType = "mockApiUrl"
    }
    this.setState({
      url: url.startsWith("https://") || url.startsWith("http://") ? url : `https://${url}`, // eslint-disable-line no-http-protocol/no-http-protocol
      selectedType: newType,
    })
  }

  handleTypeChange(type) {
    const { apiType } = this.props
    let newUrl = this.state.url
    if (type === "mockApiUrl") {
      newUrl = MOCK_API_URLS[apiType] || API_URLS.mockApiUrl
    } else if (type === apiType) {
      newUrl = API_URLS[apiType] // should remove cookie and set default
    }
    this.setState({
      url: newUrl,
      selectedType: type,
    })
  }

  saveUrl() {
    if (this.state.url === API_URLS[this.props.apiType]) {
      // setting default production url
      Cookies.remove(`${this.props.apiType}`, window.Skypicker.cookieOptions)
    } else {
      Cookies.set(`${this.props.apiType}`, this.state.url, window.Skypicker.cookieOptions)
    }
    this.props.changeApiUrl(this.state.url)
  }

  render() {
    const { apiType, title, options } = this.props

    apiButtons[0].value = apiType // fill either apiUrl or bookingApiUrl or authApiUrl or locationsApiUrl

    const currentApiSetUrl = options.get(apiType)

    return (
      <div className="ChangeAPISection">
        <h4>{title}</h4>
        <RadioButtons
          modes={apiButtons.filter(
            apiButton => !(apiButton.value === "mockApiUrl" && MOCK_API_URLS[apiType] === ""),
          )}
          active={this.state.selectedType}
          handleChange={this.handleTypeChange}
        />
        <div className="ChangeAPISection-content">
          <NewTextField
            value={this.state.url}
            onChange={this.handleUrlChange}
            placeholder={apiType}
          />
          <Button disabled={this.state.url === currentApiSetUrl} onClick={this.saveUrl}>
            Change
          </Button>
        </div>
      </div>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    options: state.options,
  }),
  (dispatch, props) => ({
    changeApiUrl: url => {
      dispatch(setOption(props.apiType, url))
      constants[props.apiType] = url // Hacky way, but hard to change it other way.
    },
  }),
)(ChangeAPISection)
